import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { SippApi } from '../../../services/SippExpress'
import { IUrlMapState, UrlMapDocument, UrlMapState } from '../urlMap.slice'

export const CreateUrlMapAsync = createAsyncThunk(
  'urlMaps/createUrlMap',
  async (body: {url: string, prefix:string, id?: string, type?: string}, { rejectWithValue }) => {
    try {
      const response = (await SippApi.createUrlMap(body, {})) as AxiosResponse<UrlMapDocument>
      return response.data
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || 'Failed request')
    }
  },
)

export const CreateUrlMapAsyncBuilder = (builder: ActionReducerMapBuilder<IUrlMapState>) => {
  builder
    .addCase(CreateUrlMapAsync.pending, (state) => {
      state.loading = true
      state.data = UrlMapState.data
      state.error = false
    })

    .addCase(CreateUrlMapAsync.fulfilled, (state, action) => {
      state.data = action.payload
      state.loading = false
    })
    .addCase(CreateUrlMapAsync.rejected, (state, action: PayloadAction<any>) => {
      state.loading = false
      state.error = true
    })
}
